'use strict';

$('.product-hotspot').hover(function () {
  var _window$refreshYotpoW, _window;
  (_window$refreshYotpoW = (_window = window).refreshYotpoWidgets) === null || _window$refreshYotpoW === void 0 ? void 0 : _window$refreshYotpoW.call(_window);
});